export default __webpack_public_path__ + "static/media/download-icon.f8dbb1e4.svg";